/**
 * API response extractors for RequestV2 — normalize similar API response shapes.
 */

export function extractCodeWrapped(body) {
  if (body == null) return body;
  if (typeof body !== "object" || !("code" in body)) return body;

  if (body.code === "0000") {
    return body.data !== undefined ? body.data : body;
  }

  const err = new Error(body.message || body.msg || "Request failed");
  err.response = { data: body, status: 200 };
  err.isBusinessError = true;
  throw err;
}

export function extractResponse(body) {
  if (body == null || body === undefined) return body;

  if (typeof body === "object" && "code" in body) {
    return extractCodeWrapped(body);
  }

  if (
    typeof body === "object" &&
    !Array.isArray(body) &&
    body?.data != null &&
    !("code" in body) &&
    Object.keys(body).length === 1
  ) {
    return body.data;
  }

  return body;
}
